import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Button, Card, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import qs from 'qs';

import Loading from '~/Components/Loading';
import Widget from '~/Components/Lancamento/Encaminhamento/PreEncaminhamento/widget';
import SenhaGrid from '~/Components/Lancamento/Encaminhamento/Encaminhamento/senhagrid';
import MesaGrid from '~/Components/Lancamento/Encaminhamento/Encaminhamento/mesagrid';
import {
  fetchEncaminhamento,
  chamarProximaSenhaEnc,
  recallSenhaEnc,
  toggleSenhaEnc,
  encaminharParaMesaEnc,
  atualizarPainelEnc,
} from '~/Store/Lancamento/Encaminhamento/actions';

class Encaminhamento extends Component {
  state = {
    codigoFamilia: null,
    mesaEspecifica: '',
    senhaParaEncaminhar: null,
    senhaRechamada: null,
  };

  refreshInterval = null;

  componentDidMount() {
    const { location } = this.props;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const codigoFamilia = parseInt(params.familia, 10);

    if (codigoFamilia) {
      this.setState({ codigoFamilia }, () => {
        this.carregarDados();
        this.iniciarAutoRefresh();
      });
    }
  }

  componentWillUnmount() {
    this.pararAutoRefresh();
  }

  carregarDados = () => {
    const { codigoFamilia } = this.state;
    if (codigoFamilia) {
      this.props.fetchEncaminhamento(codigoFamilia);
    }
  };

  iniciarAutoRefresh = () => {
    this.refreshInterval = setInterval(this.carregarDados, 30000);
  };

  pararAutoRefresh = () => {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  };

  handleChamarProxima = () => {
    const { codigoFamilia } = this.state;
    this.props.chamarProximaSenhaEnc(codigoFamilia);
  };

  handleRecall = codigoSenha => {
    const { codigoFamilia } = this.state;
    this.props.recallSenhaEnc(codigoSenha, codigoFamilia);
    this.setState({ senhaRechamada: codigoSenha });
    clearTimeout(this.recallTimeout);
    this.recallTimeout = setTimeout(() => {
      this.setState({ senhaRechamada: null });
    }, 5000);
  };

  handleToggle = codigoSenha => {
    const { codigoFamilia } = this.state;
    this.props.toggleSenhaEnc(codigoSenha, codigoFamilia);
  };

  handleEncaminhar = codigoSenha => {
    const { codigoFamilia, mesaEspecifica } = this.state;
    const mesaParsed = parseInt(mesaEspecifica, 10);
    const mesa = Number.isInteger(mesaParsed) && mesaParsed > 0 ? mesaParsed : null;
    this.props.encaminharParaMesaEnc(codigoSenha, codigoFamilia, mesa);
    this.setState({ mesaEspecifica: '' });
  };

  handleAtualizarPainel = () => {
    const { codigoFamilia } = this.state;
    this.props.atualizarPainelEnc(codigoFamilia);
  };

  handleMesaEspecificaChange = e => {
    const value = e.target.value.replace(/\D/g, '');
    this.setState({ mesaEspecifica: value });
  };

  render() {
    const { relatorio, senhas, mesas, isLoading } = this.props;
    const { codigoFamilia, mesaEspecifica } = this.state;

    if (!codigoFamilia) {
      return (
        <Container className="py-4">
          <div className="alert alert-warning">
            Nenhum empreendimento selecionado. Adicione <strong>?familia=CODIGO</strong> na URL.
          </div>
        </Container>
      );
    }

    return (
      <Container fluid className="p-4">
        <HeaderAzul title="Encaminhamento" contemPesquisa={false} />

        <Row className="mb-2 align-items-stretch">
          <Col md={3} className="d-flex">
            <div className="d-flex align-items-center p-3 bg-white rounded shadow-sm w-100">
              <div className="mr-3 text-secondary" style={{ fontSize: '2rem', opacity: 0.9 }}>
                <i className="fa fa-bullhorn" />
              </div>
              <div className="d-flex flex-column">
                <span className="font-weight-bold text-dark" style={{ fontSize: '1.5rem', lineHeight: 1 }}>
                  {relatorio.senhasChamadas}
                </span>
                <span className="text-muted" style={{ fontSize: '0.8rem', marginTop: '3px' }}>
                  Senhas Chamadas
                </span>
              </div>
            </div>
          </Col>
          <Col md={3} className="d-flex">
            <div className="d-flex align-items-center p-3 bg-white rounded shadow-sm w-100">
              <div className="mr-3 text-secondary" style={{ fontSize: '2rem', opacity: 0.9 }}>
                <i className="fa fa-user" />
              </div>
              <div className="d-flex flex-column">
                <span className="font-weight-bold text-dark" style={{ fontSize: '1.5rem', lineHeight: 1 }}>
                  {relatorio.pessoasAtendidas}
                </span>
                <span className="text-muted" style={{ fontSize: '0.8rem', marginTop: '3px' }}>
                  Pessoas Atendidas
                </span>
              </div>
            </div>
          </Col>
          <Col md={3} className="d-flex">
            <div className="d-flex align-items-center p-3 bg-white rounded shadow-sm w-100">
              <div className="mr-3 text-secondary" style={{ fontSize: '2rem', opacity: 0.9 }}>
                <i className="fa fa-desktop" />
              </div>
              <div className="d-flex flex-column">
                <span className="font-weight-bold text-dark" style={{ fontSize: '1.5rem', lineHeight: 1 }}>
                  {relatorio.mesasDisponiveis}
                </span>
                <span className="text-muted" style={{ fontSize: '0.8rem', marginTop: '3px' }}>
                  Mesas Disponíveis
                </span>
              </div>
            </div>
          </Col>
          <Col md={3} className="d-flex flex-column">
            <Button
              variant="success"
              block
              onClick={this.handleChamarProxima}
              className="font-weight-bold text-uppercase d-flex align-items-center justify-content-center w-100"
              style={{ fontSize: '1.5rem' }}
            >
              Chamar Próxima Senha
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              block
              onClick={this.handleAtualizarPainel}
              className="mt-2 mb-0"
            >
              <i className="fa fa-refresh mr-1" /> Atualizar Painel
            </Button>
          </Col>
        </Row>

        <Row className="mb-1 align-items-center">
          <Col md={3}>
            <div className="d-flex align-items-center">
              <Form.Control
                type="text"
                placeholder="Nº Mesa"
                value={mesaEspecifica}
                onChange={this.handleMesaEspecificaChange}
                maxLength={3}
                style={{ width: '150px' }}
                className="mr-2"
              />
              <small className="text-muted mr-1">Mesa específica</small>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-mesa-especifica">
                    Preencha para encaminhar para uma mesa específica. Deixe vazio para a próxima disponível.
                  </Tooltip>
                }
              >
                <FaInfoCircle className="text-info" style={{ cursor: 'pointer' }} />
              </OverlayTrigger>
            </div>
          </Col>
          <Col md={6}></Col>
          <Col md={3}></Col>
        </Row>

        <Row>
          <Col md={7}>
            <div className="d-flex align-items-center flex-wrap mb-1">
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#ebffe8', display: 'inline-block', borderRadius: '3px', border: '1px solid #ccc' }}></span>
              <small className="mr-2">Chamada</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#fff3cd', display: 'inline-block', borderRadius: '3px' }}></span>
              <small className="mr-2">Encaminhada</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#65D1C2', display: 'inline-block', borderRadius: '3px' }}></span>
              <small className="mr-2">Em Atendimento</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#f8d7da', display: 'inline-block', borderRadius: '3px' }}></span>
              <small className="mr-2">Inativa</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#d6d8db', display: 'inline-block', borderRadius: '3px' }}></span>
              <small>Finalizada</small>
            </div>
            <Card className="mb-3">
              <Card.Body style={{ padding: '0' }}>
                {isLoading && senhas.length === 0 ? (
                  <Loading />
                ) : (
                  <SenhaGrid
                    senhas={senhas}
                    onRecall={this.handleRecall}
                    onToggle={this.handleToggle}
                    onEncaminhar={this.handleEncaminhar}
                    senhaRechamada={this.state.senhaRechamada}
                  />
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col md={5}>
            <div className="d-flex align-items-center flex-wrap mb-1">
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#90EE90', display: 'inline-block', borderRadius: '3px' }}></span>
              <small className="mr-2">Disponível</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#fff3cd', display: 'inline-block', borderRadius: '3px' }}></span>
              <small className="mr-2">Encaminhada</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#65D1C2', display: 'inline-block', borderRadius: '3px' }}></span>
              <small className="mr-2">Em Atendimento</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#f8d7da', display: 'inline-block', borderRadius: '3px' }}></span>
              <small className="mr-2">Inativa</small>
              <span className="mr-1" style={{ width: '14px', height: '14px', backgroundColor: '#666666', display: 'inline-block', borderRadius: '3px' }}></span>
              <small>Não Disponível</small>
            </div>
            <Card className="mb-3">
              <Card.Body style={{ padding: '0' }}>
                <MesaGrid mesas={mesas} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  relatorio: state.encaminhamento.encaminhamento.relatorio,
  senhas: state.encaminhamento.encaminhamento.senhas,
  mesas: state.encaminhamento.encaminhamento.mesas,
  isLoading: state.encaminhamento.encaminhamento.isLoading,
  isError: state.encaminhamento.encaminhamento.isError,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchEncaminhamento,
      chamarProximaSenhaEnc,
      recallSenhaEnc,
      toggleSenhaEnc,
      encaminharParaMesaEnc,
      atualizarPainelEnc,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Encaminhamento));